const calcPercent = (val, data) => {
  let a = val
  let b = data
  if (val < 0) {
    a = 0
  }
  if (data < 0) {
    b = 0
  }
  const result = val >= data ? '100%' : `${((a * 100) / b).toFixed(2)}%`
  return result
}
export default {
  calcPercent
}
